/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { URI } from '../../base/common/uri.js';

export const multiDiffEditorVariants = ['cards', 'noCards', 'noCardsNonCompact'] as const;
export type MultiDiffEditorVariant = (typeof multiDiffEditorVariants)[number];

export type IMultiDiffResourceId = { original: URI | undefined; modified: URI | undefined };
